import React, { Component } from "react";
import PropTypes from "prop-types";
import Spinner from "../common/Spinner";
import Emoji from "../common/Emoji";
import InvoiceTable from "./InvoiceTable";

class Invoices extends Component {
  componentDidMount() {
    this.props.getInvoices();
  }

  render() {
    const { invoices, loading } = this.props.invoices;
    let invoiceList;

    if (invoices === null || loading) {
      invoiceList = <Spinner />;
    } else {
      if (invoices.length > 0) {
        invoiceList = (
          <div>
            <InvoiceTable invoices={invoices} />
          </div>
        );
      } else {
        invoiceList = (
          <h5 className="center-message center">
            Sorry, no reports ready <Emoji symbol="😢" />
          </h5>
        );
      }
    }

    return <div className="container content">{invoiceList}</div>;
  }
}

/*Invoices.propTypes = {
  getInvoices: PropTypes.func.isRequired,
  invoices: PropTypes.object
};

const mapStateToProps = state => ({
  invoices: state.invoices
});*/

export default Invoices;



// WEBPACK FOOTER //
// ./src/components/invoices/Invoices.js